/* GemsAura → Amplitude. Same project/key as AstroAura India; every event is
   prefixed GemsAura_ and carries Store: "GemsAura" so the two never mix.

     GemsAura_Homepage_Viewed     page load, pageType "home"
     GemsAura_Product_Viewed      page load, pageType "product"
     GemsAura_Product_Added       every successful POST /cart/add (card, PDP,
                                  sticky bar, quick view, cart recs, add-on)
     GemsAura_Checkout_Opened     gemsaura-rzp.js, when the details sheet opens
     GemsAura_Checkout_Completed  gemsaura-rzp.js, after Razorpay pays + verify

   Autocapture is OFF: anything it sends ("[Amplitude] Page Viewed", sessions)
   would be un-prefixed and land in India's charts.
   Money is AED in plain properties, never Amplitude's revenue field: the
   project's revenue is India's INR Web_Shopify_Purchase, and AED would be summed
   into it. No name/email/phone/address is ever sent.
   Debug: add ?amp_debug=1 once; events are logged to the console. */
(function () {
  if (window.gaAmp) return;
  var KEY = '955e3f5f6695674ba9db9bd3a94857ad';
  var SDK = 'https://cdn.amplitude.com/libs/analytics-browser-2.11.11-min.js.gz';
  var amp = null, queue = [];

  function ls(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) {} return null; }
  function ss(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) {} return null; }
  if (/[?&]amp_debug=1/.test(location.search)) ls('ga-amp-debug', '1');
  var DEBUG = ls('ga-amp-debug') === '1';

  /* First touch of the session: campaign + landing page ride on every event. */
  var visit = {};
  try { visit = JSON.parse(ss('ga-amp-visit') || 'null') || {}; } catch (e) {}
  var qs = new URLSearchParams(location.search), utm = {};
  qs.forEach(function (v, k) { if (/^utm_(source|medium|campaign|content|term)$/.test(k)) utm[k] = v; });
  if (Object.keys(utm).length) visit.utm = utm;
  if (qs.get('fbclid')) visit.click = 'fbclid'; else if (qs.get('gclid')) visit.click = 'gclid';
  if (!visit.landing) {
    visit.landing = location.pathname;
    var ref = document.referrer && document.referrer.split('/')[2];
    visit.referrer = ref && ref !== location.host ? ref : 'direct';
  }
  ss('ga-amp-visit', JSON.stringify(visit));

  var meta = (window.ShopifyAnalytics && window.ShopifyAnalytics.meta) || {};
  function base() {
    var p = {
      'Store': 'GemsAura',
      'Page Type': (meta.page && meta.page.pageType) || '',
      '[Amplitude] Page Path': location.pathname,
      'Currency': (window.Shopify && Shopify.currency && Shopify.currency.active) || 'AED',
      'Visitor Country': ls('gaGeo') || '',
      'Landing Page': visit.landing,
      'Session Referrer': visit.referrer,
      'Click ID': visit.click || ''
    };
    var u = visit.utm || {};
    for (var k in u) p[k] = u[k];
    return p;
  }
  function track(name, props, opts) {
    var p = base(); for (var k in props) p[k] = props[k];
    if (DEBUG) console.info('[gaAmp]', name, p);
    if (amp) amp.track(name, p, opts); else queue.push([name, p, opts]);
  }
  function money(cents) { return Math.round(+cents || 0) / 100; }

  /* Which button started an add / checkout. Window capture runs before the
     theme's document handlers, and synthetic clicks (Quick View "Buy Now"
     clicks .gcart-co for the shopper) are skipped so the real button wins. */
  // First match wins. Card/modal context goes before the generic add-button
  // rule: the cards' own "Add" button also carries .add-to-cart-button.
  var SOURCES = [
    ['.gaqv-buy', 'Quick View Buy Now'], ['.gaqv-add', 'Quick View'],
    ['.grc-add', 'Cart Recommendations'],
    ['quick-add-modal, .quick-add-modal', 'Quick Add Modal'],
    ['.ga-gcard, product-card', 'Product Card'],
    ['.gpdp-sticky-add, .sticky-add-to-cart__button', 'Product Page Sticky Bar'],
    ['.gpx-cta, .add-to-cart-button, [name="add"]', 'Product Page']
  ];
  var lastClick = { src: '', t: 0 };
  addEventListener('click', function (e) {
    if (!e.isTrusted || !e.target.closest) return;
    for (var i = 0; i < SOURCES.length; i++) {
      if (e.target.closest(SOURCES[i][0])) { lastClick = { src: SOURCES[i][1], t: Date.now() }; return; }
    }
  }, true);
  function recentSource() { return Date.now() - lastClick.t < 10000 ? lastClick.src : ''; }

  function cartItems(cart) {
    return (cart.items || []).map(function (i) {
      return { product_id: i.product_id, variant_id: i.variant_id, name: i.product_title, variant: i.variant_title || '', quantity: i.quantity, price: money(i.final_price || i.price) };
    });
  }
  function cartProps(cart) {
    var items = cartItems(cart);
    return {
      'Cart Value': money(cart.total_price),
      'Cart Item Count': cart.item_count,
      'Line Count': items.length,
      'Discount Value': money(cart.total_discount),
      'Product IDs': items.map(function (i) { return i.product_id; }),
      'Variant IDs': items.map(function (i) { return i.variant_id; }),
      'Product Names': items.map(function (i) { return i.name; }),
      'Items': items
    };
  }

  /* ---- Homepage / product views ------------------------------------------ */
  var pageType = meta.page && meta.page.pageType;
  var refPath = '';
  try { var r = new URL(document.referrer); if (r.host === location.host) refPath = r.pathname; } catch (e) {}
  var fromCol = (refPath.match(/^\/collections\/([^\/]+)/) || [])[1] || '';

  if (pageType === 'home') {
    track('GemsAura_Homepage_Viewed', { 'Previous Page': refPath });
  } else if (pageType === 'product') {
    var handle = decodeURIComponent((location.pathname.match(/\/products\/([^\/?#]+)/) || [])[1] || '');
    var sp = meta.product || {};
    var pv = function (p) {
      var vid = +qs.get('variant');
      var vs = p.variants || sp.variants || [];
      var v = vs.filter(function (x) { return x.id === vid; })[0] || vs.filter(function (x) { return x.available; })[0] || vs[0] || {};
      var price = money(v.price), was = money(v.compare_at_price);
      track('GemsAura_Product_Viewed', {
        '[Amplitude] Product ID': p.id || sp.id,
        '[Amplitude] Product Name': p.title || '',
        '[Amplitude] Product Handle': handle,
        '[Amplitude] Product Variant ID': v.id || null,
        'Variant Title': v.public_title || v.title || '',
        '[Amplitude] Product Price': price,
        'Compare At Price': was > price ? was : null,
        'Discount Percent': was > price ? Math.round((was - price) / was * 100) : 0,
        'Product Type': p.type || sp.type || '',
        'Vendor': p.vendor || sp.vendor || '',
        'Available': v.available !== undefined ? !!v.available : null,
        'Variant Count': vs.length,
        '[Amplitude] Product URL': location.origin + location.pathname,
        'Previous Page': refPath,
        'From Collection': fromCol
      });
    };
    if (handle) {
      fetch('/products/' + encodeURIComponent(handle) + '.js').then(function (r) { if (!r.ok) throw 0; return r.json(); })
        .then(pv).catch(function () { pv({}); });
    } else pv({});
  }

  /* ---- Add to cart: every add path on this theme POSTs /cart/add(.js) ------ */
  function parseAdd(body) {
    var out = [];
    try {
      if (typeof body === 'string') {
        var j = null; try { j = JSON.parse(body); } catch (e) {}
        if (j) { (j.items || [j]).forEach(function (i) { out.push({ id: +i.id, qty: +i.quantity || 1 }); }); return out; }
        body = new URLSearchParams(body);
      }
      if (body && typeof body.get === 'function' && body.get('id')) out.push({ id: +body.get('id'), qty: +body.get('quantity') || 1 });
    } catch (e) {}
    return out;
  }
  function onAdded(req, res, src) {
    var lines = res && (res.items || (res.variant_id ? [res] : []));
    if (!lines || !lines.length) return;
    origFetch('/cart.js').then(function (r) { return r.json(); }).catch(function () { return null; }).then(function (cart) {
      lines.forEach(function (li, i) {
        var want = req.filter(function (x) { return x.id === li.variant_id; })[0];
        var qty = want ? want.qty : 1, price = money(li.final_price || li.price);
        var p = {
          '[Amplitude] Product ID': li.product_id,
          '[Amplitude] Product Variant ID': li.variant_id,
          '[Amplitude] Product Name': li.product_title,
          'Variant Title': li.variant_title || '',
          '[Amplitude] Product Price': price,
          '[Amplitude] Product Quantity': qty,
          'Line Value': Math.round(price * qty * 100) / 100,
          'Product Type': li.product_type || '',
          'Vendor': li.vendor || '',
          '[Amplitude] Product Handle': li.handle || '',
          '[Amplitude] Product URL': li.url ? location.origin + li.url.split('?')[0] : '',
          // The PDP CTA posts [product, add-on] together; the 2nd line is the add-on.
          'Add Source': src === 'Product Page' && i > 0 ? 'Product Page Add-on' : (src || 'Other')
        };
        if (cart) { p['Cart Value After Add'] = money(cart.total_price); p['Cart Item Count After Add'] = cart.item_count; }
        track('GemsAura_Product_Added', p);
      });
    });
  }
  var origFetch = window.fetch;
  if (origFetch) {
    window.fetch = function (input, init) {
      var pr = origFetch.apply(this, arguments);
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        var method = (init && init.method) || (input && input.method) || 'GET';
        if (/^post$/i.test(method) && /\/cart\/add(\.js)?(\?|$)/.test(url.replace(/^https?:\/\/[^\/]+/, ''))) {
          var req = parseAdd(init && init.body), src = recentSource();
          pr.then(function (r) { if (r.ok) return r.clone().json().then(function (b) { onAdded(req, b, src); }); }).catch(function () {});
        }
      } catch (e) {}
      return pr;
    };
  }

  /* ---- Checkout: called from gemsaura-rzp.js -------------------------------- */
  window.gaAmp = {
    track: track,
    checkoutOpened: function (cart, trigger) {
      var src = recentSource() === 'Quick View Buy Now' ? 'Quick View Buy Now' : (trigger || 'Other');
      ss('ga-amp-co', JSON.stringify({ t: Date.now(), src: src }));
      var p = cartProps(cart);
      p['Checkout Source'] = src;
      p['Has Saved Address'] = !!ls('grzp-addr');
      track('GemsAura_Checkout_Opened', p);
    },
    checkoutCompleted: function (o) {
      var co = {}; try { co = JSON.parse(ss('ga-amp-co') || '{}'); } catch (e) {}
      var res = o.res || {}, cart = o.cart || {};
      var p = cartProps(cart);
      p['Order Number'] = o.order || null;
      // false = Razorpay took the money but /verify returned no Shopify order.
      p['Order Confirmed'] = !!o.order;
      p['Razorpay Payment ID'] = res.razorpay_payment_id || '';
      p['Razorpay Order ID'] = res.razorpay_order_id || '';
      p['Value'] = money(o.amount);
      p['Num Items'] = cart.item_count;
      p['Emirate'] = o.emirate || '';
      p['Checkout Source'] = co.src || '';
      p['Seconds In Checkout'] = co.t ? Math.round((Date.now() - co.t) / 1000) : null;
      track('GemsAura_Checkout_Completed', p, res.razorpay_payment_id ? { insert_id: 'gemsaura_completed_' + res.razorpay_payment_id } : undefined);
      try { if (amp) amp.flush(); } catch (e) {}
    }
  };

  /* ---- SDK: own instance, so nothing else on the page can re-init it --------- */
  var s = document.createElement('script');
  s.async = true; s.src = SDK;
  s.onload = function () {
    try {
      var A = window.amplitude; if (!A) return;
      var inst = typeof A.createInstance === 'function' ? A.createInstance() : A;
      inst.init(KEY, { serverZone: 'US', autocapture: false });
      if (A.Identify) inst.identify(new A.Identify().set('Store', 'GemsAura'));
      amp = inst; window.gaAmpInstance = inst;
      queue.splice(0).forEach(function (q) { amp.track(q[0], q[1], q[2]); });
    } catch (e) {}
  };
  (document.head || document.documentElement).appendChild(s);
})();

/* GemsAura: Razorpay Standard Checkout on the cart Checkout button (AED, Apple Pay via Razorpay). */
(function () {
  if (window.__grzp) return; window.__grzp = 1;
  var KEY = 'rzp_live_Tejke9QSEuwLsx', API = 'https://bgyxbktjwx.us-east-1.awsapprunner.com/gemsaura/rzp/';
  var ON = true;
  try { if (/[?&]rzp=0/.test(location.search)) localStorage.setItem('grzp', '0'); if (/[?&]rzp=1/.test(location.search)) localStorage.setItem('grzp', '1'); var f = localStorage.getItem('grzp'); if (f === '0') ON = false; } catch (e) {}
  var GEO = ''; try { GEO = localStorage.getItem('gaGeo') || ''; } catch (e) {}
  var ABROAD = GEO && GEO !== 'AE';
  if (ABROAD) {
    var gb = function () {
      if (document.getElementById('ga-uae') || !document.body) return;
      var b = document.createElement('div'); b.id = 'ga-uae'; b.setAttribute('role', 'note');
      b.style.cssText = 'background:#1c2a22;color:#F5F0E8;font-family:inherit;font-weight:500;font-size:12.5px;line-height:1.4;letter-spacing:.02em;text-align:center;padding:8px 14px';
      b.textContent = 'We currently deliver within the UAE only.';
      document.body.insertBefore(b, document.body.firstChild);
    };
    if (document.body) gb(); else document.addEventListener('DOMContentLoaded', gb);
  }
  if (!ON) return;
  try { if (/utm_/.test(location.search)) sessionStorage.setItem('grzp-utm', location.search); } catch (e) {}
  var st = document.createElement('style'); st.textContent = '#grzp{position:fixed;inset:0;z-index:2147483000;visibility:hidden;pointer-events:none;transition:visibility 0s linear .32s;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Inter,Roboto,Helvetica,Arial,sans-serif;-webkit-font-smoothing:antialiased}#grzp.on{visibility:visible;pointer-events:auto;transition:visibility 0s}#grzp *{box-sizing:border-box}#grzp .grzp-scrim{position:absolute;inset:0;background:rgba(0,0,0,.6);opacity:0;transition:opacity .3s ease}#grzp.on .grzp-scrim{opacity:1}#grzp .grzp-panel{position:absolute;inset:0;display:flex;flex-direction:column;margin:0;background:#fcfcfc;color:#1e2329;overflow:hidden;opacity:0;transform:scale(.985);transition:opacity .25s ease,transform .3s cubic-bezier(.2,.8,.2,1)}#grzp.on .grzp-panel{opacity:1;transform:none}@media(min-width:700px){#grzp .grzp-panel{inset:auto;left:50%;top:50%;width:400px;height:min(640px,92vh);margin:0;border-radius:12px;box-shadow:0 20px 60px rgba(0,0,0,.35);transform:translate(-50%,-50%) scale(.97)}#grzp.on .grzp-panel{transform:translate(-50%,-50%)}}#grzp .grzp-hd{flex:none;display:flex;align-items:center;gap:12px;padding:14px 16px 16px;background:#557adf;color:#fff}#grzp .grzp-x{width:32px;height:32px;display:grid;place-items:center;margin-left:-6px;border:0;border-radius:50%;background:none;color:#fff;cursor:pointer}#grzp .grzp-x:hover{background:rgba(255,255,255,.15)}#grzp .grzp-logo{width:52px;height:52px;flex:none;display:grid;place-items:center;border-radius:10px;background:#fff;overflow:hidden}#grzp .grzp-logo img{width:44px;height:auto;display:block}#grzp .grzp-hd b{font-size:20px;font-weight:600;letter-spacing:-.01em}#grzp .grzp-hd small{display:block;margin-top:2px;font-size:12px;font-weight:400;opacity:.85}#grzp .grzp-bd{flex:1;overflow:auto;padding:18px 16px 12px;margin-top:-6px;border-radius:12px 12px 0 0;background:#fcfcfc}#grzp .grzp-ttl{margin:4px 0 14px;font-size:17px;font-weight:600;color:#2b2f36}#grzp .grzp-card{display:grid;gap:14px;padding:16px;border:1px solid #e6e7ea;border-radius:10px;background:#fff}#grzp label{display:grid;gap:6px;min-width:0}#grzp label>span{font-size:13px;font-weight:500;color:#5b6270}#grzp input,#grzp select{width:100%;height:46px;padding:0 12px;border:1px solid #d5d8de;border-radius:6px;background:#fff;color:#1e2329;font:inherit;font-size:15px;outline:0;-webkit-appearance:none;appearance:none;transition:border-color .15s,box-shadow .15s}#grzp select{background:#fff url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' width=\'12\' height=\'8\'%3E%3Cpath d=\'M1 1l5 5 5-5\' fill=\'none\' stroke=\'%235b6270\' stroke-width=\'1.6\'/%3E%3C/svg%3E") no-repeat right 12px center;padding-right:32px}#grzp input:focus,#grzp select:focus{border-color:#557adf;box-shadow:0 0 0 3px rgba(85,122,223,.15)}#grzp .grzp-ph{display:flex;gap:8px}#grzp .grzp-ph em{flex:none;display:grid;place-items:center;width:72px;height:46px;border:1px solid #d5d8de;border-radius:6px;font-style:normal;font-size:15px;color:#1e2329;background:#f6f7f9}#grzp .grzp-2{display:grid;grid-template-columns:1fr 1fr;gap:12px}@media(max-width:380px){#grzp .grzp-2{grid-template-columns:1fr}}#grzp .grzp-geo{margin:0 0 12px;padding:10px 12px;border-radius:8px;background:#fff8e6;border:1px solid #f5dfa8;color:#7a5200;font-size:13px;line-height:1.45}#grzp .grzp-err{margin:12px 0 0;color:#d93025;font-size:13px}#grzp .grzp-sec{display:flex;align-items:center;justify-content:center;gap:6px;margin:16px 0 4px;font-size:12px;color:#7a8190}#grzp .grzp-sec b{color:#2b2f36;font-weight:600}#grzp .grzp-ft{flex:none;display:flex;align-items:center;gap:14px;padding:12px 16px calc(12px + env(safe-area-inset-bottom));background:#fff;border-top:1px solid #eceef1;box-shadow:0 -4px 12px rgba(0,0,0,.04)}#grzp .grzp-amt{flex:1;min-width:0}#grzp .grzp-amt b{display:block;font-size:20px;font-weight:700;color:#1e2329}#grzp .grzp-amt small{font-size:12px;color:#7a8190}#grzp .grzp-pay{flex:none;min-width:150px;height:48px;padding:0 24px;border:0;border-radius:8px;background:#43474e;color:#fff;font:inherit;font-size:16px;font-weight:600;cursor:pointer;transition:background .15s,transform .1s}#grzp .grzp-pay:hover{background:#2f3237}#grzp .grzp-pay:active{transform:scale(.98)}#grzp .grzp-pay:disabled{opacity:.7;cursor:default}#grzp .grzp-ok{display:grid;justify-items:center;gap:8px;padding:40px 10px;text-align:center}#grzp .grzp-ok i{width:60px;height:60px;border-radius:50%;display:grid;place-items:center;background:#22a06b;color:#fff;font-style:normal;font-size:28px;animation:grzpPop .45s cubic-bezier(.34,1.56,.64,1)}#grzp .grzp-ok i.wait{background:#557adf}#grzp .grzp-ok b{font-size:18px;color:#1e2329}#grzp .grzp-ok p{margin:0;font-size:14px;line-height:1.5;color:#5b6270}#grzp .grzp-ok small{color:#7a8190;font-size:12px}#grzp .grzp-cf{position:absolute;inset:0;z-index:10;display:grid;place-items:center;padding:16px;background:rgba(0,0,0,.45);opacity:0;visibility:hidden;transition:opacity .2s ease,visibility 0s linear .2s}#grzp .grzp-cf.on{opacity:1;visibility:visible;transition:opacity .2s ease}#grzp .grzp-cf-in{position:relative;width:min(100%,420px);padding:28px 22px 22px;border-radius:14px;background:#fff;text-align:center;transform:translateY(10px) scale(.98);transition:transform .25s cubic-bezier(.2,.8,.2,1)}#grzp .grzp-cf.on .grzp-cf-in{transform:none}#grzp .grzp-cf-x{position:absolute;top:10px;right:10px;width:34px;height:34px;border:0;border-radius:50%;background:none;font-size:16px;cursor:pointer;color:#1e2329}#grzp .grzp-cf-art{display:grid;place-items:center;height:130px;margin:6px 0 18px;border-radius:14px;background:#eef0fb}#grzp .grzp-cf b{display:block;font-size:20px;font-weight:700;color:#1e2329}#grzp .grzp-cf p{margin:8px 0 22px;font-size:14.5px;color:#4b5260}#grzp .grzp-cf-stay,#grzp .grzp-cf-go{display:block;width:100%;height:50px;border-radius:10px;font:inherit;font-size:16px;font-weight:600;cursor:pointer}#grzp .grzp-cf-stay{border:1.5px solid #c9ccd3;background:#fff;color:#1e2329}#grzp .grzp-cf-go{margin-top:12px;border:0;background:linear-gradient(180deg,#2a2e36,#0d0f13);color:#fff}@keyframes grzpPop{from{transform:scale(.4);opacity:0}}#grzp .grzp-ld{position:absolute;inset:0;z-index:5;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:0;background:#fcfcfc;transition:opacity .25s ease}#grzp .grzp-ld i{width:26px;height:26px;border-radius:50%;border:2.5px solid rgba(85,122,223,.2);border-top-color:#557adf;animation:grzpSpin .7s linear infinite}@keyframes grzpSpin{to{transform:rotate(360deg)}}#grzp .grzp-panel.ready .grzp-ld{opacity:0;pointer-events:none}#grzp .grzp-hd,#grzp .grzp-bd,#grzp .grzp-ft{opacity:0;transition:opacity .35s ease .1s}#grzp .grzp-panel.ready .grzp-hd,#grzp .grzp-panel.ready .grzp-bd,#grzp .grzp-panel.ready .grzp-ft{opacity:1}@keyframes grzpDraw{to{stroke-dashoffset:0}}@keyframes grzpShield{from{transform:scale(1)}to{transform:scale(1.04)}}'; document.head.appendChild(st);
  var EMIRATES = ['Dubai', 'Abu Dhabi', 'Sharjah', 'Ajman', 'Ras Al Khaimah', 'Fujairah', 'Umm Al Quwain'];
  var LOGO = 'https://cdn.shopify.com/s/files/1/0627/9849/5847/t/7/assets/ga-logo-black.png?v=1';
  var sheet, cart;

  function money(c) { return 'AED ' + (c / 100).toFixed(2); }
  function loadRzp(cb) {
    if (window.Razorpay) return cb();
    var s = document.createElement('script'); s.src = 'https://checkout.razorpay.com/v1/checkout.js'; s.onload = function () { cb(); }; s.onerror = function () { cb(new Error('load')); }; document.head.appendChild(s);
  }
  function saved() { try { return JSON.parse(localStorage.getItem('grzp-addr') || '{}'); } catch (e) { return {}; } }
  function unlockPage() {
    document.documentElement.style.overflow = ''; document.body.style.overflow = '';
    document.documentElement.classList.remove('gcart-lock');
    var pw = document.querySelector('.page-wrapper'); if (pw) pw.style.overflow = '';
  }
  function closeCartDrawer() {
    var gc = document.getElementById('gcart'); if (gc) { gc.classList.remove('on'); gc.setAttribute('aria-hidden', 'true'); }
    unlockPage();
  }
  var BACK = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>';
  var LOCK = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><rect x="5" y="11" width="14" height="9" rx="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/></svg>';

  function build() {
    if (sheet) return;
    sheet = document.createElement('div'); sheet.id = 'grzp'; sheet.setAttribute('role', 'dialog'); sheet.setAttribute('aria-modal', 'true'); sheet.setAttribute('aria-label', 'Checkout');
    sheet.innerHTML = '<div class="grzp-scrim"></div><form class="grzp-panel" novalidate>' + '<div class="grzp-ld" aria-hidden="true"><i></i></div>'
      + '<div class="grzp-hd"><button type="button" class="grzp-x" aria-label="Close">' + BACK + '</button><span class="grzp-logo"><img src="' + LOGO + '" alt=""></span><div><b>GemsAura</b><small>gemsaura.store</small></div></div>'
      + '<div class="grzp-bd">'
      + '<p class="grzp-ttl">Delivery details</p>'
      + (ABROAD ? '<p class="grzp-geo">We deliver within the UAE only. Please use a UAE delivery address and mobile number.</p>' : '')
      + '<div class="grzp-card">'
      + '<label><span>Full name</span><input name="name" autocomplete="name" required></label>'
      + '<label><span>Mobile number</span><div class="grzp-ph"><em>+971</em><input name="phone" inputmode="tel" autocomplete="tel-national" placeholder="50 123 4567" required></div></label>'
      + '<label><span>Email</span><input name="email" type="email" autocomplete="email" placeholder="you@example.com" required></label>'
      + '<div class="grzp-2"><label><span>Emirate</span><select name="emirate" required>' + EMIRATES.map(function (e) { return '<option>' + e + '</option>'; }).join('') + '</select></label>'
      + '<label><span>Area</span><input name="area" autocomplete="address-level2" placeholder="e.g. Dubai Marina" required></label></div>'
      + '<label><span>Building, flat / villa, street</span><input name="address" autocomplete="street-address" required></label>'
      + '</div>'
      + '<p class="grzp-err" hidden></p>'
      + '<p class="grzp-sec">' + LOCK + ' Secured by <b>Razorpay</b></p>'
      + '</div>'
      + '<div class="grzp-ft"><div class="grzp-amt"><b data-t></b><small data-n></small></div><button class="grzp-pay" type="submit">Continue</button></div>'
      + '</form>';
    document.body.appendChild(sheet);
    var form = sheet.querySelector('form'), d = saved();
    ['name', 'phone', 'email', 'emirate', 'area', 'address'].forEach(function (k) { if (d[k]) form.elements[k].value = d[k]; });
    sheet.querySelector('.grzp-scrim').onclick = askClose; sheet.querySelector('.grzp-x').onclick = askClose;
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && sheet.classList.contains('on')) { var cf = sheet.querySelector('.grzp-cf.on'); if (cf) cf.classList.remove('on'); else askClose(); } });
    form.addEventListener('submit', function (e) { e.preventDefault(); pay(form); });
  }
  function open(trigger) {
    build();
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      cart = c; if (!c.item_count) return;
      sheet.querySelector('[data-n]').textContent = c.item_count + (c.item_count > 1 ? ' items' : ' item');
      sheet.querySelector('[data-t]').textContent = money(c.total_price);
      closeCartDrawer();
      document.documentElement.style.overflow = 'hidden';
      var pn = sheet.querySelector('.grzp-panel'); pn.classList.remove('ready');
      void sheet.offsetWidth; sheet.classList.add('on');
      setTimeout(function () { pn.classList.add('ready'); }, 450);
      try { if (window.gaAmp) window.gaAmp.checkoutOpened(c, trigger); } catch (e) {}
    });
  }
  function askClose() {
    if (!sheet) return;
    var cf = sheet.querySelector('.grzp-cf');
    if (!cf) {
      cf = document.createElement('div'); cf.innerHTML = '<div class="grzp-cf" role="alertdialog" aria-modal="true" aria-labelledby="grzpCfT"><div class="grzp-cf-in"><button type="button" class="grzp-cf-x" aria-label="Close">&#10005;</button><div class="grzp-cf-art"><svg viewBox="0 0 120 120" width="96" height="96" aria-hidden="true"><rect x="30" y="22" width="60" height="78" rx="3" fill="#d9dce6"/><rect x="34" y="30" width="24" height="68" fill="#f7f8fc" stroke="#9aa1b2" stroke-width="2" transform="skewY(4) translate(0,-2)"/><rect x="62" y="30" width="24" height="68" fill="#f7f8fc" stroke="#9aa1b2" stroke-width="2" transform="skewY(-4) translate(0,6)"/><rect x="46" y="10" width="28" height="12" rx="2" fill="#c0392b"/><text x="60" y="19" text-anchor="middle" font-size="8" font-weight="700" fill="#fff" font-family="sans-serif">EXIT</text><ellipse cx="72" cy="104" rx="5" ry="2.4" fill="#3a3f4b"/><ellipse cx="84" cy="108" rx="5" ry="2.4" fill="#3a3f4b"/><ellipse cx="94" cy="104" rx="5" ry="2.4" fill="#3a3f4b"/></svg></div><b id="grzpCfT">Are you sure you want to exit?</b><p>You will be taken back to the GemsAura website</p><button type="button" class="grzp-cf-stay">Continue to payment</button><button type="button" class="grzp-cf-go">Yes, exit</button></div></div>'; cf = cf.firstChild; sheet.appendChild(cf);
      cf.querySelector('.grzp-cf-stay').onclick = function () { cf.classList.remove('on'); };
      cf.querySelector('.grzp-cf-x').onclick = function () { cf.classList.remove('on'); };
      cf.querySelector('.grzp-cf-go').onclick = function () { cf.classList.remove('on'); close(); };
    }
    void cf.offsetWidth; cf.classList.add('on');
  }
  function close() { if (!sheet) return; sheet.classList.remove('on'); unlockPage(); }
  function err(m) { var p = sheet.querySelector('.grzp-err'); p.textContent = m; p.hidden = !m; }
  function body(html) { var b = sheet.querySelector('.grzp-bd'), ft = sheet.querySelector('.grzp-ft'); b.innerHTML = html; if (ft) ft.style.display = 'none'; return b; }

  function pay(form) {
    var v = {}; ['name', 'phone', 'email', 'emirate', 'area', 'address'].forEach(function (k) { v[k] = (form.elements[k].value || '').trim(); });
    v.phone = v.phone.replace(/\D/g, '').replace(/^(971|0)/, '');
    if (!v.name || !v.area || !v.address) return err('Please fill in all delivery details.');
    if (!/^\d{8,9}$/.test(v.phone)) return err('Enter a valid UAE mobile number.');
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v.email)) return err('Enter a valid email.');
    err(''); try { localStorage.setItem('grzp-addr', JSON.stringify(v)); } catch (e) {}
    var btn = form.querySelector('.grzp-pay'); btn.disabled = true;
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      cart = c;
      if (!c.item_count) { btn.disabled = false; return err('Your cart is empty.'); }
      var utm = {};
      try { var q = new URLSearchParams(sessionStorage.getItem('grzp-utm') || location.search); q.forEach(function (val, k) { if (/^utm_/.test(k)) utm[k] = val; }); } catch (e) {}
      fetch(API + 'order', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({
        lines: c.items.map(function (i) { var l = { variant_id: i.variant_id, quantity: i.quantity }; if (i.properties && Object.keys(i.properties).length) l.properties = i.properties; return l; }), cart_total: c.total_price,
        customer: { name: v.name, phone: '+971' + v.phone, email: v.email, emirate: v.emirate, area: v.area, address: v.address }, utm: utm
      }) }).then(function (r) { return r.json(); }).then(function (o) {
        if (!o.ok) { btn.disabled = false; return err(o.err || 'Payment is unavailable right now.'); }
        loadRzp(function (e2) {
          btn.disabled = false;
          if (e2 || !window.Razorpay) return err('Could not load the payment window. Please try again.');
          sheet.classList.remove('on');
          var rz = new Razorpay({
            key: o.key || KEY, order_id: o.order_id, amount: o.amount, currency: 'AED', name: 'GemsAura', description: c.item_count + (c.item_count > 1 ? ' items' : ' item'),
            image: 'https://cdn.shopify.com/s/files/1/0627/9849/5847/t/7/assets/ga-logo-black.png?v=1',
            prefill: { name: v.name, email: v.email, contact: '+971' + v.phone }, theme: { color: '#1d4ed8' },
            handler: function (res) { confirm(res, c, v, o.amount); },
            modal: { ondismiss: function () { err(''); void sheet.offsetWidth; sheet.classList.add('on'); document.documentElement.style.overflow = 'hidden'; } }
          });
          rz.on('payment.failed', function (r) { err((r && r.error && r.error.description) || 'Payment failed. Please try again.'); });
          rz.open();
        });
      }).catch(function () { btn.disabled = false; err('Payment is unavailable right now. Please try again.'); });
    }).catch(function () { btn.disabled = false; err('Something went wrong. Please try again.'); });
  }

  function confirm(res, c, v, amt) {
    sheet.classList.add('on'); document.documentElement.style.overflow = 'hidden';
    body('<div class="grzp-ok"><i class="wait">&#8987;</i><b>Confirming your order…</b><p>Please do not close this window.</p></div>');
    fetch(API + 'verify', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(res) })
      .then(function (r) { return r.json(); }).catch(function () { return {}; })
      .then(function (o) { done(res, c, v, amt, o && o.order); });
  }
  function done(res, c, v, amt, orderName) {
    try { localStorage.setItem('grzp-last', JSON.stringify({ id: res.razorpay_payment_id, total: amt, order: orderName, at: Date.now() })); } catch (e) {}
    try { if (window.fbq) fbq('track', 'Purchase', { value: amt / 100, currency: 'AED' }); } catch (e) {}
    try { if (window.gtag) gtag('event', 'purchase', { transaction_id: orderName || res.razorpay_payment_id, value: amt / 100, currency: 'AED' }); } catch (e) {}
    try { if (window.gaAmp) window.gaAmp.checkoutCompleted({ res: res, cart: c, amount: amt, order: orderName, emirate: v.emirate }); } catch (e) {}
    fetch('/cart/clear.js', { method: 'POST' }).catch(function () {});
    var b = body('<div class="grzp-ok"><i>&#10003;</i><b>' + (orderName ? 'Order ' + orderName + ' confirmed' : 'Payment received') + '</b><p>Thank you, ' + v.name.split(' ')[0].replace(/[<>&]/g, '') + '. ' + money(amt) + ' paid. A confirmation is on its way to your email.</p><small>Payment ID: ' + res.razorpay_payment_id + '</small></div>'
      + '<button type="button" class="grzp-pay grzp-home" style="width:100%">Continue shopping</button>');
    b.querySelector('.grzp-home').onclick = function () { location.href = '/'; };
    sheet.querySelector('.grzp-x').onclick = function () { location.href = '/'; };
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.gcart-co, a[href="/checkout"], a[href^="/checkout?"], button[name="checkout"], input[name="checkout"]');
    if (!a) return;
    e.preventDefault(); e.stopImmediatePropagation(); open(a.classList.contains('gcart-co') ? 'Cart Drawer' : 'Checkout Link');
  }, true);
  document.addEventListener('submit', function (e) {
    var f = e.target; if (!f || !f.action || !/\/checkout\b/.test(f.action) && !(f.querySelector && f.querySelector('[name="checkout"]') && e.submitter && e.submitter.name === 'checkout')) return;
    e.preventDefault(); open('Checkout Form');
  }, true);
})();

